<template>
	<div class="goods-detail" v-loading="loading" v-if="detail">
		<div class="preview-wrap">
			
			<!-- , { size: 'big' } -->
			<div class="magnifier-wrap" ><pic-zoom ref="PicZoom" :url="$img(detail.thumb)" :scale="2"></pic-zoom></div>

			<div class="spec-items">
				<!-- <span class="left-btn iconfont iconarrow-left-copy" :class="{ move: moveThumbLeft }" @click="changeThumbImg('prev')"></span> -->
				<!-- <span class="right-btn iconfont iconarrow-right" :class="{ move: moveThumbRight }" @click="changeThumbImg('next')"></span> -->
				
				<!-- 设备缩率图 暂时注释-->
				<!-- <ul :style="{ left: 30 + thumbPosition + 'px' }">
					<li v-for="(item, index) in detail.thumbs" :key="index" @mousemove="picZoomUrl = item" :class="{ selected: picZoomUrl == item }">
						<img :src="$img(item)" @error="imageErrorSpec(index)" />
					</li>
				</ul> -->
			</div>
		</div>
		
		<!-- 设备信息 -->
		<div class="basic-info-wrap"  >
			<h1>{{ detail.title }}</h1>
			<p class="desc ns-text-color" >{{ detail.introduce }}</p>
			<div class="item-block">
				<div class="promotion-price">
					<dl class="item-line">
						<dt class="ns-text-color-gray">价格</dt>
						<dd v-if="detail.price >0">
							<em class="yuan ns-text-color">¥</em>
							<span class="price ns-text-color">{{ detail.price }}</span>
						</dd>
						<div class="price price ns-text-color" v-else>
							面议
						</div>
					</dl>
				</div>
			</div>
			<div class="item-line ">
				<dt>所在地</dt>
				<dd>
					<span>
						{{detail.area.name}}
					</span>
				</dd>
			</div>
			<div class="item-line ">
				<dt>联系方式</dt>
				<dd>
					<span v-if="token">
						{{detail.tel || detail.email || detail.phone || shopInfo.telephone || shopInfo.mobile || shopInfo.email || '暂无'}}
					</span>
					<span v-else>
						请登录查看
					</span>
				</dd>
			</div>
			<dl class="item-line service">
				<dt>服务</dt>
				<dd>
					<span>
						由于此设备的特殊性,具体安装或运输请资讯
						<router-link :to="'/shop' + shopInfo.site_id" class="ns-text-color">{{ shopInfo.site_name }}</router-link>
						具体信息
						<!-- 发货并提供售后服务 -->
					</span>
				</dd>
			</dl>
			<hr class="divider" />
			<dl class="item-line buy-btn">
				<dt></dt>
				<dd>
					<template v-if="detail.status == 1">
						<el-button type="primary" plain @click="see">询价</el-button>
					</template>
					<template v-else>
						<el-button type="info" plain disabled>该设备已过期</el-button>
					</template>
					<div href="javascript:;" class="go-phone">
						<!-- <img src="@/assets/images/goods/qrcode.png" /> -->
						<!-- <div class="qrcode-wrap"><img :src="qrcode" alt="二维码图片" /></div> -->
					</div>
				</dd>
			</dl>

			<dl
				class="item-line merchant-service"
				v-show="
					shopInfo.shop_baozh == 1 ||
						shopInfo.shop_qtian == 1 ||
						shopInfo.shop_zhping == 1 ||
						shopInfo.shop_erxiaoshi == 1 ||
						shopInfo.shop_tuihuo == 1 ||
						shopInfo.shop_shiyong == 1 ||
						shopInfo.shop_shiti == 1 ||
						shopInfo.shop_xiaoxie == 1
				"
			>
				<dt>商家服务</dt>
				<div>
					<dd v-if="shopInfo.shop_shiti == 1">
						<i class="el-icon-success"></i>
						<span class="ns-text-color-gray" title="实体验证">实体验证</span>
					</dd>
				</div>
			</dl>
		</div>

		<!-- 店铺信息 -->
		<div class="shop-wrap">
			<div class="head-wrap">
				<div class="img-wrap">
					<img
						class="img-responsive center-block"
						:src="shopInfo.avatar ? $img(shopInfo.avatar) : $img(defaultShopImage)"
						@error="shopInfo.avatar = defaultShopImage"
						:alt="shopInfo.site_name"
					/>
				</div>
				<h5>
					<span class="site-name">{{ shopInfo.site_name }}</span>
					<!-- <el-tag class="tag" size="small" v-if="shopInfo.is_own == 1">自营</el-tag> -->
				</h5>
			</div>
			<div class="info-wrap">
				{{shopInfo.seo_description}}
			</div>
			<!-- <div class="info-wrap">
				<dl>
					<dt class="site-score">店铺评分</dt>
					<dd><el-rate v-model="score" disabled></el-rate></dd>
					<dt>设备描述：</dt>
					<dd>
						<span>{{ shopInfo.shop_desccredit }}</span>
						分
					</dd>
					<dt>卖家服务：</dt>
					<dd>
						<span>{{ shopInfo.shop_servicecredit }}</span>
						分
					</dd>
					<dt>发货速度：</dt>
					<dd>
						<span>{{ shopInfo.shop_deliverycredit }}</span>
						分
					</dd>
				</dl>
			</div> -->
			<div class="info-wrap" v-if="shopInfo.telephone">
				<dl>
					<dt>联系电话：</dt>
					<dd>{{ shopInfo.telephone }}</dd>
				</dl>
			</div>
			<div class="operation">
				<el-button class="btn btn-default" size="medium" @click="$router.pushToTab('shop-' + shopInfo.site_id)">查看公司</el-button>
				<!-- <el-button size="medium" @click="follow" v-if="hasFollow">取消关注</el-button> -->
				<!-- <el-button size="medium" @click="follow" v-else>关注店铺</el-button> -->
			</div>
		</div>
		
		<div class="detail-wrap">
			<div class="goods-recommended"><goods-recommend /></div>
			
			<el-tabs class="goods-tab" v-model="tabName" type="card" @tab-click="tabChange">
				<el-tab-pane label="设备详情" name="detail">
					<div v-html="detail.content"></div>
				</el-tab-pane>
				<el-tab-pane label="设备属性" name="attr">
					<!-- <ul class="attr-list">
						<template v-if="goodsSkuDetail.goods_attr_format && goodsSkuDetail.goods_attr_format.length > 0">
							<li v-for="(item, index) in goodsSkuDetail.goods_attr_format" :key="index">{{ item.attr_name }}：{{ item.attr_value_name }}</li>
						</template>
					</ul> -->
				</el-tab-pane>
				
			</el-tabs>
		</div>
	</div>
</template>

<script>
import PicZoom from 'vue-piczoom';
import detail from './public/detail';
import GoodsRecommend from '@/components/GoodsRecommend';
export default {
	name: 'detail',
	components: {
		PicZoom,
		GoodsRecommend
	},
	mixins: [detail]
};
</script>
<style lang="scss">
@import './public/detail.scss';
</style>
